import { API_BASE_URL } from "@kupikupi/brand";
import { useQuery } from "@tanstack/react-query";
import { trackDomestic } from "../endpoints/logistics";
import { useBackendCurrency, useBackendLang } from "../lang-context";
import type { DomesticTrack } from "../types/logistics";

/**
 * Domestic (China-side) seller-waybill trace for one express number.
 *
 * Lazy by design: pass `enabled: false` until the user expands the waybill so
 * we don't fan out a request per item on page load. The order-detail UI flips
 * `enabled` true on first expand and the result is cached per
 * waybill+lang+currency.
 */
export function useDomesticTrack(
  authToken: string | null,
  expressNo: string | null | undefined,
  enabled = true,
) {
  const lang = useBackendLang();
  const currency = useBackendCurrency();
  return useQuery<DomesticTrack[]>({
    queryKey: ["logistics", "track", "domestic", expressNo, lang, currency],
    enabled: enabled && !!authToken && !!expressNo,
    queryFn: () => {
      if (!authToken) throw new Error("NO_TOKEN");
      if (!expressNo) throw new Error("NO_EXPRESS_NO");
      return trackDomestic({ baseUrl: API_BASE_URL }, authToken, expressNo, { lang, currency });
    },
    staleTime: 60_000,
  });
}
